import { makeVar, useReactiveVar } from '@apollo/client';

const scorekeeperPrefsVar = makeVar({
  showRealNames: false,
});

export const useShowRealNames = () => {
  const scorekeeperPrefs = useReactiveVar(scorekeeperPrefsVar);

  const setShowRealNames = (showRealNames) => {
    scorekeeperPrefsVar({
      ...scorekeeperPrefs,
      showRealNames,
    });
  };

  return [
    scorekeeperPrefs.showRealNames,
    setShowRealNames,
  ];
};
